import { render, staticRenderFns } from "./pharmacy.vue?vue&type=template&id=bbdcbeb2&"
import script from "./pharmacy.vue?vue&type=script&lang=js&"
export * from "./pharmacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports